import Scrollbar from './../vendor/splide/scrollbar';
import { breakpoints, spacing } from './../vendor/tailwind';

document.addEventListener('alpine:init', () => {
  window.Alpine.data('scrollSlider', (amountOfSlides, perPage = 4, additionalSettings = {}, id = '') => ({
    init () {
      const options = {
        type: 'slide',
        gap: spacing['10'],
        perPage,
        perMove: 1,
        arrows: amountOfSlides > perPage,
        drag: amountOfSlides > perPage,
        scrollbar: amountOfSlides > perPage,
        lazyLoad: "nearby",
        pagination: false,
        breakpoints: {
          [breakpoints.md]: {
            perPage: 1,
            gap: spacing['6'],
            arrows: amountOfSlides > 1,
            drag: amountOfSlides > 1,
            scrollbar: amountOfSlides > 1,
            padding: {
              right: spacing['10'],
            },
          },
        },
        ...additionalSettings,
      };

      const splide = new window.Splide(this.$el, options).mount({ Scrollbar });

      window.addEventListener("splide-go", (event) => {
        if (event.detail.id === id) {
          splide.go(event.detail.slide);
        }
      });

      splide.on('active', ($slide) => {
        window.dispatchEvent(new CustomEvent('splide-active', {
          detail: {
            id: id,
            index: $slide.index,
          }
        }));
      });
    }
  }));
});
